import React from "react";
import { Classes, Dialog } from "@blueprintjs/core";
import RunProjectView from "./RunProjectView/RunProjectView";

type Props = {
    toggle: () => void;
    isOpen: boolean;
    taskId: string | undefined;
};
export default function RunProgressDialog({ isOpen, toggle, taskId }: Props) {
    return (
        <Dialog isOpen={isOpen} onClose={toggle} icon="automatic-updates" title="Run Status">
            <div className={Classes.DIALOG_BODY}>{taskId && <RunProjectView taskId={taskId} />}</div>
        </Dialog>
    );
}
